let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jZf5h")).then(() => parcelRequire('kQq9o'));